/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AllFilesActions/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ButtonIconLabel from 'DesignSystem/ButtonIconLabel/index'
import FolderIcon from 'DesignSystem/Svgs/FolderIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AllFilesActions({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/AllFilesActions"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={4}
 text="Documents"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Documents'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Documents'))}
>
{childProps => (
<FolderIcon
{...childProps}
  viewPath={`${viewPath}/FolderIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={4}
 text="Images"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../ImageSeries'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../ImageSeries'))}
>
{childProps => (
<FolderIcon
{...childProps}
  viewPath={`${viewPath}/FolderIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
{children}
</React.Fragment>)
}